import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import InfiniteScroll from 'react-infinite-scroller'

import styles from './styles'
import { Loading, Card } from 'components'
import { PlaceholderContent } from 'utils'
import { useFeedQuery } from 'graphql/__generated__/graphql'
import { ITag } from 'src/models'

const useStyles = makeStyles(styles)

const Stories: React.FunctionComponent<any> = props => {
	const {
		// companySlug,
		companyName,
		canEdit,
	} = props
	const classes = useStyles()
	// const { t } = useTranslation()
	// const { data, loading, fetchMore, refetch } = useFeedarticlesQuery({
	// 	fetchPolicy: 'network-only',
	// 	variables: {
	// 		// language: i18n.language,
	// 		userid: null,
	// 		companyslug: companySlug,
	// 		teamid: null,
	// 		first: 3,
	// 		after: null,
	// 	},
	// })
	const { data, error, loading, fetchMore } = useFeedQuery({
		fetchPolicy: 'network-only',
		variables: {
			first: 3,
			after: null,
			companyName: companyName.trim(),
		},
	})
	if (loading) {
		return (
			<div style={{ flexGrow: 1, display: 'flex' }}>
				<Loading size={48} />
			</div>
		)
	}
	if (error) {
		return <div>Error! {error.message}</div>
	}

	const articles = data
		? data?.feedCollection?.edges?.map(edge => {
				return edge?.node
		  })
		: []
	const hasNextPage = data
		? data?.feedCollection?.pageInfo?.hasNextPage
		: false

	// const articles = data
	// 	? data &&
	// 	  data.feedArticles &&
	// 	  data.feedArticles?.edges?.map(edge => edge.node)
	// 	: []
	// const hasNextPage = data
	// 	? data &&
	// 	  data?.feedArticles &&
	// 	  data?.feedArticles?.pageInfo?.hasNextPage
	// 	: false

	return (
		<>
			<Grid
				className={classes.profileMainContent}
				container={true}
				direction="column"
			>
				<Grid
					item={true}
					className={`${classes.sectionContent} ${classes.storiesSection}`}
				>
					{!loading ? (
						<section
							style={{
								flexGrow: 1,
								display: 'flex',
								flexDirection: 'column',
							}}
						>
							<InfiniteScroll
								pageStart={0}
								loadMore={() =>
									fetchMore({
										variables: {
											after: data?.feedCollection?.edges[
												data.feedCollection?.edges
													.length - 1
											].cursor,
										},
										updateQuery: (
											previousQueryResult,
											{ fetchMoreResult },
										) => {
											if (
												!fetchMoreResult ||
												!fetchMoreResult.feedCollection
											) {
												return previousQueryResult
											}

											const {
												edges: newEdges,
												pageInfo,
											} = fetchMoreResult.feedCollection

											return newEdges.length > 0
												? {
														// Put the new articles at the end of the list and update `pageInfo`
														feedCollection: {
															__typename:
																previousQueryResult
																	?.feedCollection
																	?.__typename,
															edges: [
																...(previousQueryResult
																	?.feedCollection
																	?.edges ||
																	[]),
																...newEdges,
															],
															pageInfo,
														},
												  }
												: previousQueryResult
										},
									})
								}
								hasMore={hasNextPage ?? false}
								loader={
									<div
										style={{ flexGrow: 1, display: 'flex' }}
										key={'loading'}
									>
										<Loading size={48} />
									</div>
								}
							>
								{articles && articles.length ? (
									articles?.map((article: any) => {
										const articleMedia: Array<{
											media_type?: string | null
											path?: string | null
											width?: number | null
											height?: number | null
											order?: number | null
										}> | null =
											article?.article_media &&
											article?.article_media.length > 0
												? article.article_media?.map(
														(am: string) =>
															JSON.parse(am),
												  )
												: null
										const user: {
											uid: string
											email: string
											profile: {
												isPublic: boolean | null
												hasAvatar: boolean
												avatarPath: string
												profileCoverContentType:
													| string
													| null
												coverPath: string | null
												firstName: string
												lastName: string
												full_name: string
											}
										} | null = article.user
											? JSON.parse(article.user)
											: null

										const tags: ITag[] =
											article?.tags?.map(
												(tag: string) => {
													const tagData: {
														id: string
														votes: number
														createdAt: string
														tag: {
															id: string
															title: string
														}
													} = JSON.parse(tag)

													return {
														...tagData,
														title:
															tagData.tag
																?.title || '',
													}
												},
											) || []

										return (
											<Card
												article={{
													...article,
													__typename: 'Article',
													body: article.body || '',
													featuredVideo:
														articleMedia?.find(
															articleMedia =>
																articleMedia.media_type ===
																'video',
														)?.path || null,
													featuredVideoWidth:
														articleMedia?.find(
															articleMedia =>
																articleMedia.media_type ===
																'video',
														)?.width || null,
													featuredVideoHeight:
														articleMedia?.find(
															articleMedia =>
																articleMedia.media_type ===
																'video',
														)?.height || null,
													featuredImage:
														article.featuredImage
															? {
																	filename:
																		(process
																			.env
																			.REACT_APP_R2_PATH ??
																			'') +
																			`articles/${article.id}/${article.filename}` ||
																		undefined,
															  }
															: articleMedia?.find(
																	articleMedia =>
																		articleMedia.media_type ===
																		'image',
															  )
															? {
																	filename:
																		(process
																			.env
																			.REACT_APP_R2_PATH ??
																			'') +
																		articleMedia?.find(
																			articleMedia =>
																				articleMedia.media_type ===
																				'image',
																		)?.path,
															  }
															: null,
													user: {
														__typename: 'User',
														id:
															article.userId ||
															'',
														uid: user?.uid || '',
														email:
															user?.email || '',
														god: false,
														profileCollection: {
															__typename:
																'ProfileConnection',
															edges: [
																{
																	__typename:
																		'ProfileEdge',
																	node: {
																		id:
																			article.userId ??
																			'',
																		firstName:
																			user
																				?.profile
																				.firstName ||
																			'',
																		lastName:
																			user
																				?.profile
																				.lastName ||
																			'',
																	},
																},
															],
														},
													},
													tags,
												}}
												key={article.id}
												// refetch={refetch}
												canEdit={canEdit}
											/>
										)
									})
								) : (
									<PlaceholderContent data={companyName} />
								)}
							</InfiniteScroll>
						</section>
					) : (
						<div
							style={{
								flexGrow: 1,
								display: 'flex',
								marginTop: 110,
							}}
						>
							<Loading size={58} />
						</div>
					)}
				</Grid>
			</Grid>
		</>
	)
}

export default memo(Stories)
